<template>
    <div class="social-links">
        <div v-for="(value, key, index) in items" :key="index" class="social-links-item">
            <a
                v-if="value && value.length > 0 && (value.includes('https://') || value.includes('http://'))"
                :href="value"
                target="_blank"
                rel="noopener noreferrer"
                :class="`social-links__icon social-links__icon_${key}`"
            >
                <component
                    :is="`${socialNetworks[key]}`"
                    class="social-links__svg"
                ></component>
            </a>
        </div>
    </div>
</template>

<script>
import YappyIcon from '@/assets/images/icons/yappy.svg?inline';
import RutubeIcon from '@/assets/images/icons/rutube.svg?inline';
import YoutubeIcon from '@/assets/images/icons/youtube.svg?inline';
import TelegramIcon from '@/assets/images/icons/telegram.svg?inline';
import IntagramIcon from '@/assets/images/icons/instagram.svg?inline';
import OkIcon from '@/assets/images/icons/ok.svg?inline';
import VkIcon from '@/assets/images/icons/vk.svg?inline';
import ZenIcon from '@/assets/images/icons/dzen.svg?inline';
import TikTokIcon from '@/assets/images/icons/tiktok.svg?inline';
import TenchatIcon from '@/assets/images/icons/tenchat.svg?inline';

export default {
    name: 'SocialNetworks',
    components: {
        YappyIcon,
        RutubeIcon,
        YoutubeIcon,
        TelegramIcon,
        IntagramIcon,
        OkIcon,
        VkIcon,
        ZenIcon,
        TikTokIcon,
        TenchatIcon,
    },
    data: () => ({
        socialNetworks: {
            vk: 'VkIcon',
            ok: 'OkIcon',
            yt: 'YoutubeIcon',
            tiktok: 'TikTokIcon',
            zen: 'ZenIcon',
            telegram: 'TelegramIcon',
            rutube: 'RutubeIcon',
            yappy: 'YappyIcon',
            tenchat: 'TenchatIcon',
        },
    }),
    props: {
        netWorks: Object,
    },
    computed: {
        items() {
            Object.keys(this.netWorks).forEach(key => {
                if (!this.netWorks[key]) {
                    delete this.netWorks[key];
                }
            });

            return this.netWorks;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';

.social-links {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;
    @include on-mobile {
        flex-wrap: wrap;
    }

    &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 rem(6) rem(6) 0;
        padding: rem(2);
        width: rem(40);
        height: rem(40);
        border-radius: 50%;

        &:last-of-type {
            margin-right: 0;
        }

        @include on-mobile {
            margin: 0 mrem(8) mrem(8) 0;
            width: mrem(40);
            height: mrem(40);
        }

        &_white-blue {
            color: #93c2e8;
            background: #fff;
        }
    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        color: inherit;
        border-radius: 50%;
        padding: 2px;
        width: mrem(32);
        height: auto;

        &_tiktok {
            circle {
                stroke-width: 0;
            }
        }

        @include on-desktop {
            width: rem(64);
            height: auto;
            cursor: pointer;

            &_tiktok {
                circle {
                    stroke-width: 1;
                }
            }

            &:hover {
                path {
                    fill: #fff;
                }
            }
        }

        circle {
            transition: all ease-in 0.1s;
        }

        &_yt:hover {
            @include on-desktop {
                circle {
                    fill: #c4302b;
                }
            }
        }

        &_telegram:hover {
            @include on-desktop {
                circle {
                    fill: #039be5;
                }
            }
        }

        &_ok:hover {
            @include on-desktop {
                circle {
                    fill: #ed812b;
                }
            }
        }

        &_vk:hover {
            @include on-desktop {
                circle {
                    fill: #0077ff;
                }
            }
        }
        &_zen:hover {
            @include on-desktop {
                circle {
                    fill: #2c3036;
                }
            }
        }
        &_rutube:hover {
            @include on-desktop {
                circle {
                    fill: #1c293e;
                }
                .rutube-top-circle {
                    fill: #ed143b;
                }
            }
        }
        &_yappy:hover {
            @include on-desktop {
                circle {
                    fill: #00e5bc;
                }
                .black-fill {
                    fill: #000;
                }
            }
        }
        &_tenchat:hover {
            @include on-desktop {
                circle {
                    fill: #FC3234;
                }
            }
        }
        &_tiktok:hover {
            @include on-desktop {
                circle {
                    fill: #fff;
                    stroke: #000;
                }

                path {
                    fill: #000;
                }
            }
        }
    }

    &__svg {
        border-radius: 50%;
        width: mrem(60);

        @include on-desktop {
          width: rem(35)!important;
          height: rem(35)!important;
        }
    }
}
</style>
